import { Button, Dialog } from "@rio-cloud/rio-uikit";
import Card from "@rio-cloud/rio-uikit/Card";
import { useT } from "@hooks";

export interface InactivateConfirmDialogProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  entityLabelForQuestion: string;
  entityName: string;
  importantMessage: string;
}

const InactivateConfirmDialog = ({
  show,
  onClose,
  onConfirm,
  title,
  entityLabelForQuestion,
  entityName,
  importantMessage,
}: InactivateConfirmDialogProps) => {
  const t = useT();
  return (
    <Dialog
      show={show}
      title={<span className="text-medium text-size-16">{title}</span>}
      body={
        <div className="padding-20">
          <div className="display-flex flex-column align-items-center justify-content-center">
            <span className="rioglyph rioglyph-ban-circle text-size-h2 text-color-danger" aria-hidden="true"></span>
            <p>{t("dialog.inactivate.question", { entity: entityLabelForQuestion, name: entityName })}</p>
          </div>
          <Card className="margin-top-10 bg-highlight-lightest">
            <div className="display-flex justify-content-start gap-10">
              <span
                className="rioglyph rioglyph-light-bulb text-size-h2 text-color-map-marker-route margin-top-2"
                aria-hidden="true"
              ></span>
              <div className="width-100pct">
                <div className="text-size-18 text-medium">{t("common.label.important")}</div>
                <div className="text-color-gray">{importantMessage}</div>
              </div>
            </div>
          </Card>
        </div>
      }
      footer={
        <div className="display-flex flex-wrap gap-10 justify-content-end">
          <Button onClick={onClose} className="rounded-small width-100pct-xs">
            {t("common.action.cancel")}
          </Button>
          <Button onClick={onConfirm} bsStyle={Button.PRIMARY} className="rounded-small width-100pct-xs">
            {t("common.action.inactivate")}
          </Button>
        </div>
      }
      onClose={onClose}
      className="exampleDialog"
      showCloseButton
      bsSize="md"
    />
  );
};

export default InactivateConfirmDialog;
